<template>
  <div>
    <div class="row" v-if="!loading">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between">
          <h1 class="h3 mb-3 text-gray-800">
            {{ $t("GESTÃO DA FAMÍLIA") }}
          </h1>
          <b-button-group v-if="!loading">
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>

            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar para Excel')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>
    </div>

    <b-card class="shadow">
      <div class="row">
        <div class="col-12" v-if="loading == false">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="addFamilia"
              >
                <i class="fas fa-plus" />
                <span class="px-2">{{ $t("CADASTRAR") }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="col-12" v-if="viewFilterReport">
          <form @submit.prevent="getFamilias" ref="formFiltros">
            <div class="row">
              <div class="col-md-8">
                <label><b>Pesquisar</b></label>
                <div class="input-group">
                  <b-input
                    placeholder="Pesquisar por: ID, Código Cadúnico, Nome Completo, CPF, NIS ou Endereço"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    aria-describedby="input-search"
                    @keydown.enter.prevent="getFamilias"
                  />
                  <div
                    class="input-group-append"
                    role="button"
                    @click.prevent="getFamilias"
                  >
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
                <p class="small text-muted">
                  No campo acima você pode pesquisar por: ID, Código Cadúnico,
                  Nome Completo, Nome Social, CPF, NIS, ou Endereço
                </p>
              </div>

              <form-select
                v-model="filtroOutras"
                grid="4"
                label="Outras Opções"
                :itens="$root.arrays.outras_opcoes_filtro_familia"
              />

              <form-calendar
                v-model="data_inicio"
                grid="4"
                label="Data Inicial"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_fim"
                grid="4"
                label="Data Final"
                :required="verificaDataInicial"
                :min-date="data_inicio"
                :max-date="dataNow"
              />

              <form-select
                v-model="filtroStatus"
                grid="4"
                label="Estado Cadastral"
                :itens="$root.arrays.estado_cadastral_familia_filtros"
              />

              <form-select
                ref="select"
                grid="6"
                :label="$t('Bairro/Localidade')"
                placeholder="Digite o bairro e aguarde o resultado"
                :itens="localidades"
                v-model="filtroLocalidade"
                @selected="setLocalidade"
                @search="searchLocalidade"
                :loading="loadingLocalidade"
              />

              <form-select
                ref="selectLogradouro"
                grid="6"
                :label="$t('Logradouro')"
                :itens="logradouros"
                v-model="filtroLogradouro"
                :loading="loadingLogradouro"
                placeholder="Digite o nome do logradouro e aguarde"
                :disabled="disableLogradouro"
              />

              <!--
              <form-toggle
                v-model="showfiltroNomeSocial"
                grid="12"
                label="Filtrar por Nome Social"
              />
              -->

              <div class="col-md-8" v-if="showfiltroNomeSocial">
                <label><b>Nome Social</b></label>
                <div class="input-group">
                  <b-input
                    placeholder="Nome Social"
                    class="form-control search-input"
                    type="text"
                    v-model="filtroNomeSocial"
                    aria-describedby="input-search"
                    @keydown.enter.prevent="getFamilias"
                  />
                  <div
                    class="input-group-append"
                    role="button"
                    @click.prevent="getFamilias"
                  >
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>

              <form-select
                v-if="showfiltroNomeSocial"
                grid="4"
                v-model="filtroOrigemNomeSocial"
                :itens="$root.arrays.origem_nome_social"
                label="Origem do Nome Social"
                multiple
              />
            </div>

            <div class="row pt-2 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default btn-sm"
                  @click.prevent="viewFilterReport = false"
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>
                <button
                  class="btn btn-success btn-submit btn-sm"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Filtrar") }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <load mode="table" v-if="loading" message="Carregando Famílias" />
        <div v-else class="col-12">
          <div>
            <a v-if="!showName" @click.prevent="mostrarNome" href="#"
              ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
            >
            <a v-else @click.prevent="ocultarNome" href="#"
              ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
            >
          </div>
          <print-content>
            <template v-slot:datas>
              <p v-if="datas.start">
                Período de pesquisa selecionado:
                <b>{{ datas.start }} - {{ datas.end }}</b>
                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </b-link>
              </p>
            </template>
            <b-table
              :fields="[
                {
                  key: 'responsavel_familiar',
                  label: $t('Responsável Familiar'),
                },
                {
                  key: 'endereco',
                  label: $t('Endereço'),
                },
                {
                  key: 'familiares_ativos',
                  label: $t('Membros'),
                },
                {
                  key: 'estado_cadastral',
                  label: $t('Estado Cadastral'),
                },
                // {
                //   key: 'cadastro',
                //   label: $t('Datas'),
                // },
                {
                  key: 'actions',
                  label: '',
                  class: 'text-right no-print',
                  thStyle: {
                    width: '95px',
                    minWidth: '95px',
                  },
                },
              ]"
              :items="familiasList"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
            >
              <template v-slot:cell(responsavel_familiar)="data">
                <span v-if="data.item.responsavel_familiar">
                  <strong
                    v-if="!data.item.responsavel_familiar.nome_social"
                    v-html="
                      $options.filters.highlight(
                        data.item.responsavel_familiar.nome_completo,
                        search.trim()
                      )
                    "
                  ></strong>

                  <span v-else>
                    <strong
                      v-if="showfiltroNomeSocial"
                      v-html="
                        $options.filters.highlight(
                          data.item.responsavel_familiar.nome_social,
                          filtroNomeSocial
                        )
                      "
                    ></strong>
                    <strong v-else>{{
                      data.item.responsavel_familiar.nome_social
                    }}</strong>
                    <strong>( N.R.: )</strong>
                    <strong
                      v-if="showName"
                      v-html="
                        $options.filters.highlight(
                          data.item.responsavel_familiar.nome_completo,
                          search.trim()
                        )
                      "
                    ></strong>
                  </span>
                </span>

                <span v-else>
                  <strong class="text-danger">FAMÍLIA SEM RESPONSÁVEL</strong>
                </span>

                <br />
                <small class="text-muted" v-if="data.item.responsavel_familiar">
                  <!-- <span v-if="data.item.data_nascimento">
                                            Idade:
                                             <br />
                                        </span> -->
                  Data de Nascimento:
                  <span v-if="data.item.responsavel_familiar.data_nascimento">
                    {{
                      data.item.responsavel_familiar.data_nascimento
                        | formatDate
                    }}
                    <span v-if="data.item.responsavel_familiar.idade"
                      >({{ parseInt(data.item.responsavel_familiar.idade) }}
                      ano(s))
                    </span>
                  </span>
                  <alert-icon v-else message="Data de Nascimento em branco" />
                  <br />
                  <!-- Posição Familiar:
                                        {{ data.item.posicao_familiar_nome }}
                                        <br /> -->
                  <span v-if="data.item.responsavel_familiar.cpf">
                    CPF:
                    <strong
                      v-html="
                        $options.filters.highlight(
                          data.item.responsavel_familiar.cpf,
                          search
                        )
                      "
                    ></strong>
                  </span>
                  <span v-else>
                    Documento:
                    <alert-icon
                      message="Pessoa sem documentação ou não foi inserido no cadastro!"
                    />
                  </span>
                  <br />
                  Filiação 1:
                  <strong>{{ !!data.item.responsavel_familiar.mae ? data.item.responsavel_familiar.mae : 'N/A' }}</strong>
                </small>
                <br />
                <!-- Alertas Baseados na lista outras_opcoes_filtro_familia em arrays.js-->
                <span class="d-block text-muted" v-if="filtroPerCapita">
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small v-if="data.item.financeiro">
                    Per capita
                    {{ data.item.financeiro.per_capita_familiar }}</small
                  >
                </span>

                <span
                  class="d-block text-muted"
                  v-if="data.item.trabalho_infantil == 1"
                >
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small>Trabalho infantil</small>
                </span>

                <span
                  class="d-block text-muted"
                  v-if="data.item.situacao_rua == 1"
                >
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small>Situação de rua</small>
                </span>

                <span class="d-block text-muted" v-if="data.item.migrante == 1">
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    animation="fade"
                  ></b-icon>
                  <small>Família migrante</small>
                </span>

                <span v-if="data.item.paf_em_andamento">
                  <b-link href="#" :id="'paf' + data.item.id">
                    <i class="fas fa-user-tag text-primary"></i>
                  </b-link>

                  <b-popover
                    :target="'paf' + data.item.id"
                    triggers="hover"
                    placement="right"
                  >
                    <router-link
                      :to="
                        '/dashboard/acompanhamento/edit/' +
                        data.item.paf_em_andamento.id +
                        '?familia_id=' +
                        data.item.id
                      "
                    >
                      <span v-if="data.item.paf_em_andamento">
                        PAF EM ANDAMENTO -
                        {{ data.item.paf_em_andamento.unidade.nome }}</span
                      >
                    </router-link>
                  </b-popover>
                </span>

                <span v-if="data.item.atendimentos">
                  <b-link href="#" :id="'at-' + data.item.id">
                    <i class="fas fa-hands-helping text-primary"></i>
                  </b-link>

                  <b-popover
                    :target="'at-' + data.item.id"
                    triggers="hover"
                    placement="right"
                  >
                    <span>
                      Atendimentos da Família:
                      {{ data.item.atendimentos }}
                    </span>
                  </b-popover>
                </span>
              </template>
              <template v-slot:cell(endereco)="data">
                <div
                  class="small"
                  v-if="data.item.endereco && data.item.endereco.id != null"
                >
                  <span v-if="!data.item.endereco.situacao_rua">
                    <strong>
                      <span
                        v-if="data.item.endereco.logradouro.nome_logradouro"
                        v-html="
                          $options.filters.highlight(
                            data.item.endereco.logradouro.tipo +
                              ' ' +
                              data.item.endereco.logradouro.nome_logradouro,
                            search.trim()
                          )
                        "
                      >
                      </span>
                      <span v-else class="text-warning">
                        <strong>LOGRADOURO NÃO INFORMADA</strong>
                      </span>
                    </strong>
                    <span v-if="data.item.endereco.numero_endereco"
                      >, Nº {{ data.item.endereco.numero_endereco }}</span
                    >
                    <br />
                    <span
                      v-if="data.item.endereco.localidade"
                      v-html="
                        $options.filters.highlight(
                          data.item.endereco.localidade.nome_localidade,
                          search.trim()
                        )
                      "
                    >
                    </span>
                    <span v-else class="text-warning">
                      <strong>LOCALIDADE NÃO INFORMADA</strong>
                    </span>
                    <span v-if="data.item.endereco.cep">
                      , CEP:
                      {{ data.item.endereco.cep }}
                    </span>
                  </span>
                  <span v-else>
                    Endereço de Usuário/Família em Situação de Rua<br />
                    <strong
                      v-html="
                        $options.filters.highlight(
                          data.item.endereco.referencia_endereco,
                          search.trim()
                        )
                      "
                    >
                    </strong>
                  </span>
                </div>
                <div class="text-danger" v-else>
                  <strong>FAMÍLIA SEM ENDEREÇO</strong>
                </div>
              </template>

              <template v-slot:cell(familiares_ativos)="data">
                {{ data.item.familiares_ativos }}
              </template>
              <template v-slot:cell(estado_cadastral)="data">
                <span class="small" v-html="data.item.estado_cadastral"></span>
              </template>

              <template v-slot:cell()="data">
                <b-button
                  :title="$t('Editar Família')"
                  :to="'/dashboard/familias/edit/' + data.item.id"
                  target="_blank"
                  :class="
                    data.item.estado_cadastral_id == 4 &&
                    data.item.estado_cadastral_id == 5
                      ? 'px-2 mb-0'
                      : 'px-2 m-0'
                  "
                  size="sm"
                  type="button"
                  v-b-tooltip.hover
                  variant="success"
                >
                  <i class="fas fa-edit"></i>
                </b-button>

                <!--
                Regra temporariamente desativada:
                v-if="
                  data.item.estado_cadastral_id != 4 &&
                  data.item.estado_cadastral_id != 5
                "
                -->

                <b-dropdown
                  no-caret
                  variant="info"
                  size="sm"
                  v-b-tooltip.hover
                  right
                  title="Serviços/Intervenções"
                >
                  <template #button-content>
                    <i class="fas fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-group id="dropdown-group-1" header="Intervenções">
                    <b-dropdown-item
                      @click="
                        (familiaReferenciamento = data.item.id),
                          (unidadesReferenciamentos =
                            data.item.referenciamentos),
                          openModalReferenciamento(data.item)
                      "
                      v-if="$store.state.user.role_details.name != 'Nível Básico'"
                    >
                      Referenciar Família
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="'/dashboard/atendimentos/' + data.item.id"
                      target="_blank"
                    >
                      Atendimentos
                    </b-dropdown-item>
                    <template v-if="$store.state.user.role_details.name != 'Nível Básico'">
                      <b-dropdown-item
                        :to="
                          '/dashboard/encaminhamentos/' +
                          data.item.id +
                          '?familia_id=' +
                          data.item.id
                        "
                        target="_blank"
                      >
                        Encaminhamentos
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="
                          '/dashboard/referenciamentos/' +
                          data.item.id +
                          '?familia_id=' +
                          data.item.id
                        "
                        target="_blank"
                      >
                        Referência e Contrarreferência
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="
                          '/dashboard/medidas/' +
                          data.item.id +
                          '?familia_id=' +
                          data.item.id
                        "
                        target="_blank"
                      >
                        Medidas Socioeducativas
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="
                          '/dashboard/acompanhamentos/' +
                          data.item.id +
                          '?familia_id=' +
                          data.item.id
                        "
                        target="_blank"
                      >
                        Acompanhamentos
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="
                          '/dashboard/violacaodedireitos/' +
                          data.item.id +
                          '?familia_id=' +
                          data.item.id
                        "
                        target="_blank"
                      >
                        Violação de Direitos
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="
                          '/dashboard/familia/acolhimentos/' +
                          data.item.id +
                          '?familia_id=' +
                          data.item.id
                        "
                        target="_blank"
                      >
                        Histórico de Acolhimentos
                      </b-dropdown-item>
                    </template>
                  </b-dropdown-group>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-group id="dropdown-group-2" header="Serviços" v-if="$store.state.user.role_details.name != 'Nível Básico'">
                    <b-dropdown-item
                      :to="
                        '/dashboard/familia/beneficios/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Benefícios
                    </b-dropdown-item>
                    <b-dropdown-item
                      :to="
                        '/dashboard/programassociais/beneficiarios/' +
                        data.item.id +
                        '?familia_id=' +
                        data.item.id
                      "
                      target="_blank"
                    >
                      Programas Sociais
                    </b-dropdown-item>
                  </b-dropdown-group>
                </b-dropdown>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </print-content>
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getFamilias"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>
        <router-view />
      </div>
    </b-card>

    <b-modal
      id="referenciarFamilia"
      centered
      hide-footer
      title="Referenciar Família"
      size="lg"
    >
      <div class="row">
        <load v-if="loading_referenciamento" mode="table" />
        <div v-else class="col-md-12 mb-2">
          <table class="table">
            <tr
              v-for="(ref, index) in familia_selected.referenciamentos"
              :key="ref.id"
            >
              <td>{{ ref.unidade }}</td>
              <td>{{ ref.cadastro }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-md p-0 m-0"
                  @click="
                    removeReferenciamento(ref.id, familia_selected.id, index)
                  "
                >
                  <i class="fa fa-trash text-danger"></i>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <form @submit.prevent="submitReferenciamento" ref="addItem">
        <div class="row">
          <form-select
            v-model="unidadesReferenciamentos"
            label="Adicionar Unidade"
            :itens="listunidades"
            :disabled="desabledSearchUnidade"
            :loading="loadingSearchUnidade"
            :required="true"
          />
        </div>
        <div class="row pt-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "Familias",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Famílias"),
    };
  },
  data() {
    return {
      showName: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      familiasList: [],
      localidades: [],
      logradouros: [],
      loadingLocalidade: false,
      loadingLogradouro: false,
      datas: {},
      idades: null,
      filtroStatus: null,
      filtroDatas: [],
      filtroOutras: null,
      filtroLocalidade: null,
      filtroLogradouro: null,
      filtroPerCapita: false,
      sort: {
        order: "desc",
        column: "created_at",
      },
      showfiltroNomeSocial: false,
      loading_referenciamento: false,
      filtroNomeSocial: "",
      filtroOrigemNomeSocial: [],
      unidadesReferenciamentos: [],
      familia_selected: [],
      familia_selected_index: [],
      unidades_ref_tipos: [],
      familiaReferenciamento: null,
      unidades: [],
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      disableLogradouro: true,
    };
  },
  mounted() {
    this.getFamilias();
    this.getUnidades();
  },
  computed: {
    listunidades() {
      if (this.familia_selected.referenciamentos) {
        //Criar um array com os ids das unidades referenciadas
        let referenciamento_temp = this.familia_selected.referenciamentos.map(
          (e) => e.id
        );
        //Criar um array com os tipos das unidades referenciadas
        let unidades_tipo = this.familia_selected.referenciamentos.map(
          (e) => e.tipo_id
        );

        return this.unidades.filter((unidade) => {
          let result = referenciamento_temp.includes(unidade.id);
          let result_tipos = unidades_tipo.includes(unidade.tipo_id);

          //Faz uma verificação para saber se já existe alguma unidade referenciada do mesmo tipo
          if (result_tipos) {
            return false;
          }
          /*Se não existir unidades referenciadas do mesmo tipo ou se ainda não foi referenciada o retorno deverá ser true
           * porem, como é verificado se já existe com o metodo include e ele retorna true, é necessário usar o !result para informar que
           * essa unidade não deverá ser retornada no filter
           */
          return !result;
        });
      } else {
        return this.unidades;
      }
    },
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    openModalReferenciamento(familia) {
      this.familia_selected = familia;
      this.unidades_ref_tipos = [];
      this.$bvModal.show("referenciarFamilia");
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getFamilias();
      }
    },
    changeSort() {
      if (this.sort.order === "asc") {
        this.sort.order = "desc";
      } else if (this.sort.order === "desc") {
        this.sort.order = "asc";
      }
      this.getFamilias();
    },
    getFamilias(load = true) {
      this.loading = load;

      this.datas.start = this.$options.filters.formatDate(this.data_inicio);
      this.datas.end = this.$options.filters.formatDate(this.data_fim);

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/familias", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroOutras: this.filtroOutras,
            filtroLocalidade: this.filtroLocalidade,
            filtroLogradouro: this.filtroLogradouro,
            sort: this.sort,
            //filtroNomeSocial: this.filtroNomeSocial,
            //filtroNomeSocial: this.search,
            filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
          },
        })
        .then((response) => {
          this.filtroPerCapita = this.filtroOutras == 4 ? true : false;

          this.familiasList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getFamilias();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    importarFamilias() {
      let ladda = Ladda.create(document.querySelector(".btn-importar"));
      ladda.start();
      axios.post("api/dashboard/familias/importar").then((response) => {
        ladda.stop();
        this.$snack.show({
          button: false,
          text: response.data.data.message,
        });
        ladda.stop();
      });
    },
    searchLocalidade: function searchLocalidade(search) {
      if (search != "") {
        clearTimeout(searchLocalidade.timeout);
        searchLocalidade.timeout = setTimeout(() => {
          this.loadingLocalidade = true;
          this.$refs.select.openOptions(false);
          axios
            .get(`api/dashboard/enderecos/pesquisar_bairro?q=${escape(search)}`)
            .then((response) => {
              this.localidades = response.data;
              this.$refs.select.openOptions(false);
            })
            .finally(() => {
              this.$refs.select.closeOptions(false);
              setTimeout(() => {
                this.loadingLocalidade = false;
                this.$refs.select.openOptions(true);
              }, 3000);
            });
        }, 1000);
      }
    },
    setLocalidade() {
      if (this.filtroLocalidade) {
        this.filtroLogradouro = null;
        setTimeout(() => {
          this.loadingLogradouro = true;
          this.setSelected(this.filtroLocalidade);
        }, 1000);
      }
    },
    setSelected(value) {
      if (value) {
        axios
          .get(
            `api/dashboard/enderecos/pesquisar_logradouro?localidade=${escape(
              value
            )}`
          )
          .then((response) => {
            this.logradouros = response.data;
            this.$refs.selectLogradouro.openOptions(true);
          })
          .finally(() => {
            this.loadingLogradouro = false;
            this.disableLogradouro = false;
          });
      }
    },
    searchLogradouro: function searchLogradouro(search) {
      if (search != "") {
        clearTimeout(searchLogradouro.timeout);
        searchLogradouro.timeout = setTimeout(() => {
          this.loadingLogradouro = true;
          this.$refs.selectLogradouro.openOptions(false);
          axios
            .get(
              `api/dashboard/enderecos/pesquisar_logradouro?logradouro_list_familia=${escape(
                search
              )}`
            )
            .then((response) => {
              this.logradouros = response.data;
              this.$refs.selectLogradouro.openOptions(false);
            })
            .finally(() => {
              this.$refs.selectLogradouro.closeOptions(false);
              setTimeout(() => {
                this.loadingLogradouro = false;
                this.$refs.selectLogradouro.openOptions(true);
              }, 3000);
            });
        }, 1000);
      }
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroDatas = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.filtroOutras = null;
      this.filtroLocalidade = null;
      this.filtroLogradouro = null;

      this.showfiltroNomeSocial = false;
      this.filtroNomeSocial = "";
      this.filtroOrigemNomeSocial = [];

      this.verificaDataInicial = true;

      this.getFamilias();
    },
    addFamilia() {
      swal
        .fire({
          title: "Atenção!",
          text: "Recomendamos que antes de fazer o cadastro de uma nova família seja realizada uma pesquisa detalhada para confirmar se a família já é cadastrada no sistema.",
          showCancelButton: true,
          confirmButtonText: "Cadastrar",
          cancelButtonText: "Pesquisar",
          icon: "warning",
          showCloseButton: true,
        })
        .then((value) => {
          if (value.isConfirmed == false) {
            this.viewFilterReport = true;
          }
          if (value.isConfirmed) {
            this.$router.push("/dashboard/familias/add");
          }
        });
    },
    exportar() {
      // this.loading = true;
      this.datas.start = this.$options.filters.formatDate(this.data_inicio);
      this.datas.end = this.$options.filters.formatDate(this.data_fim);

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O arquivo será exportado em formato CSV baseado na paginação atual.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });

      axios
        .get("api/dashboard/familia/export/excel", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            total: this.pagination.total,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroOutras: this.filtroOutras,
            filtroLocalidade: this.filtroLocalidade,
            filtroLogradouro: this.filtroLogradouro,
            sort: this.sort,
            filtroNomeSocial: this.filtroNomeSocial,
            filtroOrigemNomeSocial: this.filtroOrigemNomeSocial,
          },
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.loading = false));
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    submitReferenciamento() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      var dados = {
        familia: this.familiaReferenciamento,
        unidades: this.unidadesReferenciamentos,
      };
      axios
        .post(`api/dashboard/familias/unidades/sync`, dados)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Referenciamento realizado!",
          });

          this.getFamilias();
          this.$bvModal.hide("referenciarFamilia");
        })
        .finally(() => {
          ladda.stop();
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    removeReferenciamento(unidade_id, familia_id, index) {
      this.loading_referenciamento = true;
      axios
        .post(`api/dashboard/familias/unidades/remove`, {
          unidade_id: unidade_id,
          familia_id: familia_id,
        })
        .then((response) => {
          this.$snack.success({
            button: false,
            text: "Referenciamento atualizado!",
          });
          this.familia_selected.referenciamentos.splice(index, 1);
          this.getFamilias(false);
          // this.$bvModal.hide("referenciarFamilia");
        })
        .finally(() => {
          this.loading_referenciamento = false;
        });
    },
  },
};
</script>

<style scoped>
.btn-group .btn {
  padding: 6px 14px !important;
  margin-right: 0px;
}

.dropdown-menu.show {
  display: block;
  z-index: 1041 !important;
}
</style>
